import { ENDPOINTS } from "@/constants/endpoints";
import { api } from "../network/api";
import type { FileUploadDto } from "@/models/dto/file-upload.dto";

const FileUploadService = {
  uploadFile: async (dto: FileUploadDto) => {
    const formData = new FormData();
    if (Array.isArray(dto.file)) {
      dto.file.forEach((file) => {
        formData.append("files", file);
      });
    } else {
      formData.append("file", dto.file);
    }
    formData.append("path", dto.path);
    formData.append("document_type", dto.document_type);

    const response = await api.post(
      Array.isArray(dto.file)
        ? ENDPOINTS.FILE_UPLOAD_MULTIPLE
        : ENDPOINTS.FILE_UPLOAD,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        timeout: 60000,
      }
    );
    return response;
  },

  downloadCertificate: async function (key: string): Promise<Blob> {
    console.log({ key });
    const response = await api.get(ENDPOINTS.DOWNLOAD_CERTIFICATE(key), {
      responseType: "blob",
    });
    return response as unknown as Blob;
  },
};

export default FileUploadService;
